import type { StoryMeta } from "./types";
import { STORIES } from "./stories.manifest";

export function getAllStories(): StoryMeta<any>[] {
  return STORIES.slice().sort(
    (a, b) => (a.group ?? "").localeCompare(b.group ?? "") || a.title.localeCompare(b.title),
  );
}

export function findStoryById(id: string) {
  return getAllStories().find((s) => s.id === id);
}

export type { StoryMeta } from "./types";

